import { render, staticRenderFns } from "./CalendarAside.vue?vue&type=template&id=7edf2796&scoped=true&"
import script from "./CalendarAside.vue?vue&type=script&lang=js&"
export * from "./CalendarAside.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7edf2796",
  null
  
)

export default component.exports